// extracted by mini-css-extract-plugin
module.exports = {"title":"title_title__3GY1m","title-redesign":"title_title-redesign__19kNz"};